import { Link } from "react-router-dom";
import { MonitorPlay, LogOut } from "lucide-react";

export const SetupHeader = ({ sealed, onLogout }) => (
  <header className="flex flex-wrap items-end justify-between gap-4 border-b border-cyan-400/20 pb-6">
    <div>
      <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1">
        <span className="brand text-xl">The Spore Project</span>
        <span className="lab-label">Technician console</span>
      </div>
      <h1 className="spore-headline mt-2 text-3xl sm:text-4xl">Programming bench</h1>
      <p className="mt-2 max-w-xl text-sm text-slate-400">
        {sealed
          ? "The vocabulary is sealed and the site is open to research assistants."
          : "Scan a tag, name the object, let the hive write the memory it holds, preview it, save - then the next one."}
      </p>
    </div>
    <div className="flex flex-wrap gap-2">
      <Link data-testid="open-kiosk-link" to="/" className="lab-btn-ghost"><MonitorPlay size={16} /> Open kiosk</Link>
      <button data-testid="admin-logout-button" onClick={onLogout} className="lab-btn-ghost"><LogOut size={16} /> Lock</button>
    </div>
  </header>
);
